<template>
  <div class="dashboard">
    <h1>Administration</h1>
    <hr>
    <b-row>
      <b-col cols="12" sm="6" md="4" class="mb-4" v-for="(item, index) of items" :key="index">
        <b-card class="h-100">
          <div class="h-100 d-flex flex-column">
            <h2 class="h4">{{item.title}}</h2>
            <p class="mb-auto">{{item.description}}</p>
            <b-button
              class="mt-3"
              :to="item.linkType === 'to' ? item.link : null"
              :href="item.linkType === 'href' ? item.link : null"
              variant="primary"
            >{{item.buttonText}}</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  components: { },
  data: () => ({
    items: [
      {
        title: 'Statistik',
        description: 'Se brugsstatistik for ARVID (på nær, hvad der formidles via Schultz)',
        linkType: 'href',
        link: './admin/request/request/overview/',
        buttonText: 'Gå til statistik'
      },
      {
        title: 'Rapportering',
        description: 'Få vist den komplette liste af dokumenter og download denne som .csv fil.',
        linkType: 'to',
        link: {name: 'Rapportering'},
        buttonText: 'Vis rapportering'
      },
      {
        title: 'Indholdssektioner',
        description: 'Administrer det indhold, der vises på forsiden, på "Om ARVID" og i sidefoden.',
        linkType: 'to',
        link: {name: 'Indholdssektoner'},
        buttonText: 'Vis indholdssektioner'
      },
      {
        title: 'Taksonomi',
        description: 'Redigér de begreber. der findes i taksonomien.',
        linkType: 'to',
        link: {name: 'Taksonomi'},
        buttonText: 'Vis taksonomi'
      },
      {
        title: 'Brugere',
        description: 'Administrer de brugere, der har adgang til ARVID.',
        linkType: 'href',
        link: './admin/auth/',
        buttonText: 'Gå til brugeraministration'
      },
      {
        title: 'Nyhedsbrev',
        description: 'Skriv og udgiv et nyhedsbrev.',
        linkType: 'to',
        link: {name: 'Nyhedsbrev', params: { tab: 'newsletter' }},
        buttonText: 'Skriv nyhedsbrev'
      },
      {
        title: 'Modtagere',
        description: 'Administrer nyhedsbrevsmodtagere.',
        linkType: 'to',
        link: {name: 'Nyhedsbrev', params: { tab: 'recipients' }},
        buttonText: 'Vis nyhedsbrevsmodtagere'
      }
    ]
  })
}
</script>

<style>

</style>